import React from 'react';
import { setCurrentView } from 'core/utils';
import { WoundOrderEditViewStore } from '../stores';
import { observer } from 'mobx-react';
import { WoundOrderEditTemplate } from 'themes/application/wound-order/pages';

@setCurrentView((rootStore) => new WoundOrderEditViewStore(rootStore), 'woundOrderEditViewStore')
@observer
class WoundOrderEdit extends React.Component {
    render(){
        return <WoundOrderEditTemplate {...this.props} />
    }
}

export default WoundOrderEdit;